"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../Utils");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const StyledLink = exports.StyledLink = _styledComponents.default.a.attrs(() => ({
  tabIndex: 0
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    all: unset;\n    ", "\n    color: ", ";\n    cursor: pointer;\n    ", "\n    ", "\n    text-decoration: underline;\n\n    :hover {\n        ", "\n    }\n\n    :focus-within {\n        box-shadow: 0px 0px 1px 1px ", ";\n    }\n\n"])), (0, _Utils.parseTheme)('color', 'primaryColor'), _ref => {
  let {
    theme: {
      primaryColor
    }
  } = _ref;
  return primaryColor;
}, (0, _Utils.parseProp)('fontSize', 'font-size'), (0, _Utils.parseProp)('margin'), (0, _Utils.parseTheme)('color', 'primaryColor'), (0, _Utils.getTheme)('primaryColor'));